/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-alternative-state-page',
    templateUrl: './alternative-state-page.component.html',
    styleUrls: ['./alternative-state-page.component.scss']
})

export class AlternativeStatePageComponent implements OnInit {
    /**
     * The page header icon.
     */
    @Input() headerIcon: string = null;

    /**
     * The page header.
     */
    @Input() header: string = '';

    /**
     * The empty state title.
     */
    @Input() titleText: string = '';

    /**
     * The empty state message HTML
     */
    @Input() messageHtml: any = undefined;

    /**
     * The empty state message string.
     */
    @Input() messageString: any = undefined;

    /**
     * The empty state message template.
     */
    @Input() messageTemplate: any = undefined;

    /**
     * Header names for the mock table
     */
    @Input() mockTableHeaders: string[] = ['[placeholder]', '[placeholder]', '[placeholder]', '[placeholder]'];

    /**
     * The empty state image path.
     */
    @Input() imagePath: string = '';

    /**
     * The empty state add button text.
     */
    @Input() buttonOneText: string = undefined;

    /**
     * Button one callback.
     */
    @Input() buttonOneCallback: (...args: any[]) => void;

    /**
     * Disabled state for button one.
     */
    @Input() buttonOneDisabled: boolean = false;

    /**
     * Button one class.
     */
    @Input() buttonOneClass: 'primary' | 'secondary' | 'outline' = 'primary';

    /**
     * Router link for button one.
     */
    @Input() buttonOneLink: string = undefined;

    /**
     * Button two text.
     */
    @Input() buttonTwoText: string = undefined;

    /**
     * Button two callback.
     */
    @Input() buttonTwoCallback: (...args: any[]) => void;

    /**
     * Disabled state for button two.
     */
    @Input() buttonTwoDisabled: boolean = false;

    /**
     * Button two class.
     */
    @Input() buttonTwoClass: 'primary' | 'secondary' | 'outline' = 'primary';

    /**
     * Router link for button two.
     */
    @Input() buttonTwoLink: string = undefined;

    /**
     * Button three text.
     */
    @Input() buttonThreeText: string = undefined;

    /**
     * The empty state delete button callback.
     */
    @Input() buttonThreeCallback: (...args: any[]) => void;

    /**
     * Disabled state for button three.
     */
    @Input() buttonThreeDisabled: boolean = false;

    /**
     * Button three class.
     */
    @Input() buttonThreeClass: 'primary' | 'secondary' | 'outline' = 'primary';

    /**
     * Router link for button three.
     */
    @Input() buttonThreeLink: string = undefined;

    /**
     * The empty state button callback. Redirects to the subscription page.
     */
    @Input() redirectToButton: boolean = false;

    /**
     * The empty state subscription page link.
     */
    @Input() redirectToLink: string = '/cm/organisation/subscriptions';

    /**
     * Set if the content is error content.
     */
    @Input() isError: boolean = false;

    /**
     * Number of mock rows
     */
    public tableRows: any[] = Array.from(Array(5));

    /**
     * Random numbers list for widths of bars.
     */
    public randomNumbersList: number[] = [];

    /**
     * Colour list.
     */
    public colorList: any[] = [
        '#ff00a3', '#7633b0', '#00b391', '#ffa340', '#5c61d4'
    ];

    ngOnInit() {
        this.setRandomWidths();
    }

    /**
     * Set random widths.
     */
    public setRandomWidths(): void {
        const randomNumbersTotal = this.mockTableHeaders.length * this.tableRows.length;
        for (let i = 0; i < randomNumbersTotal; i++) {
            this.randomNumbersList.push(Math.floor(Math.random() * (90 - 20 + 1) + 20));
        }
    }
}
